import TableHeader from "@tiptap/extension-table-header";
import TableCell from "@tiptap/extension-table-cell";
import TableRow from "./children/table-row";
import cn from "classnames";
import "./style.scss";
import { TableCellPaste } from "./table-cell-paste";

const CustomTableCell = TableCell.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            "data-diff-node": {
                default: undefined,
                renderHTML: (attributes) => {
                    return {
                        class: cn({
                            inserted: attributes["data-diff-node"] === "inserted",
                            deleted: attributes["data-diff-node"] === "deleted",
                        }),
                    };
                },
            },
            "data-diff-id": {
                default: undefined,
            },
        };
    },
});

const CustomTableRow = TableRow.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            "data-diff-node": {
                default: undefined,
                renderHTML: (attributes) => {
                    return {
                        class: cn({
                            inserted: attributes["data-diff-node"] === "inserted",
                            deleted: attributes["data-diff-node"] === "deleted",
                        }),
                    };
                },
            },
            "data-diff-id": {
                default: undefined,
            },
        };
    },
});

const CustomTableHeader = TableHeader.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            "data-diff-node": {
                default: undefined,
                renderHTML: (attributes) => {
                    return {
                        class: cn({
                            inserted: attributes["data-diff-node"] === "inserted",
                            deleted: attributes["data-diff-node"] === "deleted",
                        }),
                    };
                },
            },
            "data-diff-id": {
                default: undefined,
            },
        };
    },
});

export const TableDependencies = [
    CustomTableHeader,
    CustomTableRow,
    CustomTableCell,
    TableCellPaste,
];
export { default as Table } from "./table";
export { default as TablePlugin } from "./table-plugin";
export { TableCellPaste } from "./table-cell-paste";
